import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const ExtraBrake = ({ extraBrake }: SpecProps<"extra_brake">) => {
  const { i18n } = useLingui();

  if (!extraBrake) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.extraBrake",
    message: "Extra brake",
    comment: "Field for 'Extra brake' for truck and bus in ad specification",
  });

  return <FieldValuePair field={field} value={extraBrake} />;
};
